"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const chart_control_options_model_1 = require("./chart-control-options.model");
/**
 * Created by mariam.melkonyan on 5/16/17.
 */
class CategoricalChartControlOptions extends chart_control_options_model_1.ChartControlOptions {
    constructor(options) {
        super(options);
        /**
         * The title of the category axis
         */
        this._categoryAxisTitle = null;
        /**
         * The title of the value axis
         */
        this._valueAxisTitle = null;
        /**
         * Defines if the category axis title should be shown
         */
        this._isCategoryAxisTitleVisible = true;
        /**
         * Defines if the value axis title should be shown
         */
        this._isValueAxisTitleVisible = true;
        /**
         * Defines if the chart has secondary axis. It can have secondary axis in the case it has at least 2 measues.
         * In the case secondary axis is enabled, the second measure's values are rendered according to that axis.
         */
        this._hasSecondaryAxis = false;
        /**
         * Defines if the stacked chart is used for percentage values
         */
        this._isStackedChartByPercent = false;
        /**
         * Defines if the chart is stacked
         */
        this._isStackedChart = false;
        this._isMeasureAxisZoomSlicerVisible = false;
        this._isCategoryAxisZoomSlicerVisible = false;
        options.isCategoryAxisTitleVisible !== undefined && (this._isCategoryAxisTitleVisible = options.isCategoryAxisTitleVisible);
        options.isValueAxisTitleVisible && (this._isValueAxisTitleVisible = options.isValueAxisTitleVisible);
        options.categoryAxisTitle !== undefined && (this._categoryAxisTitle = options.categoryAxisTitle);
        options.hasSecondaryAxis !== undefined && (this._hasSecondaryAxis = options.hasSecondaryAxis);
        options.valueAxisTitle !== undefined && (this._valueAxisTitle = options.valueAxisTitle);
        options.isStackedChart !== undefined && (this._isStackedChart = options.isStackedChart);
        options.isStackedChartByPercent !== undefined && (this._isStackedChartByPercent = options.isStackedChartByPercent);
        options.isMeasureAxisZoomSlicerVisible !== undefined && (this._isMeasureAxisZoomSlicerVisible = options.isMeasureAxisZoomSlicerVisible);
        options.isCategoryAxisZoomSlicerVisible !== undefined && (this._isCategoryAxisZoomSlicerVisible = options.isCategoryAxisZoomSlicerVisible);
    }
    set categoryAxisTitle(categoryAxisTitle) {
        this._categoryAxisTitle = categoryAxisTitle;
    }
    get categoryAxisTitle() {
        return this._categoryAxisTitle;
    }
    set valueAxisTitle(valueAxisTitle) {
        this._valueAxisTitle = valueAxisTitle;
    }
    get valueAxisTitle() {
        return this._valueAxisTitle;
    }
    set isCategoryAxisTitleVisible(isCategoryAxisTitleVisible) {
        this._isCategoryAxisTitleVisible = isCategoryAxisTitleVisible;
    }
    get isCategoryAxisTitleVisible() {
        return this._isCategoryAxisTitleVisible;
    }
    set isValueAxisTitleVisible(isValueAxisTitleVisible) {
        this._isValueAxisTitleVisible = isValueAxisTitleVisible;
    }
    get isValueAxisTitleVisible() {
        return this._isValueAxisTitleVisible;
    }
    set hasSecondaryAxis(hasSecondaryAxis) {
        this._hasSecondaryAxis = hasSecondaryAxis;
    }
    get hasSecondaryAxis() {
        return this._hasSecondaryAxis;
    }
    set isStackedChart(isStackedChart) {
        this._isStackedChart = isStackedChart;
    }
    get isStackedChart() {
        return this._isStackedChart;
    }
    set isStackedChartByPercent(isStackedChartByPercent) {
        this._isStackedChartByPercent = isStackedChartByPercent;
    }
    get isStackedChartByPercent() {
        return this._isStackedChartByPercent;
    }
    get isMeasureAxisZoomSlicerVisible() {
        return this._isMeasureAxisZoomSlicerVisible;
    }
    set isMeasureAxisZoomSlicerVisible(value) {
        this._isMeasureAxisZoomSlicerVisible = value;
    }
    get isCategoryAxisZoomSlicerVisible() {
        return this._isCategoryAxisZoomSlicerVisible;
    }
    set isCategoryAxisZoomSlicerVisible(value) {
        this._isCategoryAxisZoomSlicerVisible = value;
    }
}
exports.CategoricalChartControlOptions = CategoricalChartControlOptions;
//# sourceMappingURL=categorical-chart-control-options.model.js.map